import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, selectRoleInCommonState } from "app/app-state.index";
import { Role } from "app/shared/model/enums";
import { AppAuthService } from "app/shared/services/app-auth.service";
import { Observable, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionType } from "./permission-type.enum";



@Injectable()
export class PermissionsService {

    private _roleSubscription: Subscription;
    private _currentRole: Role;
    private _permissionsRoles: { permissionType: PermissionType, roles: Role[] }[] = [
        { permissionType: PermissionType.MY_ROULLETES, roles: [Role.User] },
        { permissionType: PermissionType.LIDS, roles: [Role.User] },
        { permissionType: PermissionType.REDEMPTION, roles: [Role.User] },
        { permissionType: PermissionType.BUSINESS_CUPON, roles: [Role.User] },
        {permissionType:PermissionType.BUSINESS_MANAGMENT,roles:[Role.Manager]}
    
    ]

    constructor(store: Store<AppState>, private authService: AppAuthService) {
        this._roleSubscription = store.select(selectRoleInCommonState).subscribe(role => {
            this._currentRole = role;
        })
    }


    permissionExists(permissionType: PermissionType): Observable<boolean> {
        let permission = this._permissionsRoles.filter(p => p.permissionType === permissionType)[0];
        if (this._currentRole) {
            return of(this._currentRole && permission && permission.roles.filter(r => r === this._currentRole).length > 0);

        } else {
            if (this.authService.isLoggedOn) {
                return this.authService.getOrLoadUserInfo().pipe(map(() => {
                    //this._currentRole = response.role;
                    return this._currentRole && permission && permission.roles.filter(r => r === this._currentRole).length > 0;
                }));
            } else {
                return of(false);
            }
        }
    }

    getRequiredRoles(permissionType: PermissionType): Role[] {
        let permission = this._permissionsRoles.filter(p => p.permissionType === permissionType)[0];
        return permission ? permission.roles : [];
    }

    ngOnDestroy() {
        if (this._roleSubscription) {
            this._roleSubscription.unsubscribe();
        }
    }

}